package se.mittpass.shared.repository

import io.ktor.client.*
import io.ktor.client.call.body
import io.ktor.client.request.*
import io.ktor.http.*
import se.mittpass.shared.api.PayrollExportSettingsDto

class FortnoxRepository(private val httpClient: HttpClient) {
    suspend fun getExportSettings(workplaceId: Long): Result<PayrollExportSettingsDto> = runCatching {
        httpClient.get("workplaces/$workplaceId/export/settings").body()
    }

    suspend fun saveExportSettings(workplaceId: Long, settings: PayrollExportSettingsDto): Result<PayrollExportSettingsDto> = runCatching {
        httpClient.put("workplaces/$workplaceId/export/settings") {
            contentType(ContentType.Application.Json)
            setBody(settings)
        }.body()
    }

    suspend fun exportPayroll(
        workplaceId: Long,
        from: String,
        to: String,
        settings: PayrollExportSettingsDto
    ): Result<String> = runCatching {
        httpClient.get("workplaces/$workplaceId/export/payroll") {
            parameter("from", from)
            parameter("to", to)
            parameter("targetSystem", settings.targetSystem)
            parameter("fileFormat", settings.fileFormat)
            parameter("employeeIdMode", settings.employeeIdMode)
            parameter("codeMode", settings.codeMode)
            parameter("codeNormal", settings.codeNormal)
            parameter("codeOb1", settings.codeOb1)
            parameter("codeOb2", settings.codeOb2)
            parameter("codeOb3", settings.codeOb3)
            parameter("onlyApproved", settings.onlyApproved.toString())
        }.body()
    }

    suspend fun exportJson(workplaceId: Long, from: String, to: String): Result<String> = runCatching {
        httpClient.get("workplaces/$workplaceId/export/fortnox") {
            parameter("from", from); parameter("to", to)
        }.body()
    }

    suspend fun exportCsv(workplaceId: Long, from: String, to: String): Result<String> = runCatching {
        httpClient.get("workplaces/$workplaceId/export/fortnox/csv") {
            parameter("from", from); parameter("to", to)
        }.body()
    }

    suspend fun exportXml(workplaceId: Long, from: String, to: String): Result<String> = runCatching {
        httpClient.get("workplaces/$workplaceId/export/fortnox/xml") {
            parameter("from", from); parameter("to", to)
        }.body()
    }
}

